<template>
	<div>
		<div v-for="link in suggestedLinks" class="link-item" @click="insertSuggested({url:link.url,name:link.name})">
			<a :title="link.name">
				<span class="favicon"><img :src="link.favicon"></span>
				<ins class="theme-color-3">{{ link.name }}</ins>
			</a>
		</div>
	</div>
</template>

<style>

	.suggested-icons {  }
	.suggested-icons h3 { font-size:.8em; text-align: center; margin-bottom: 10px }
	.suggested-icons .links-container { padding:0; margin:0; }
	.suggested-icons .link-item { margin:0 0 10px 0; }
	.suggested-icons .link-item .favicon { width:50px; height:50px }
	.suggested-icons .link-item a { width: 50px }
	.suggested-icons .link-item:first-child { border-bottom:1px solid #ccc; margin-bottom: 15px; }

</style>

<script>

	export default {
		computed:{
			config(){
				return this.$store.state.config;
			},
			suggestedLinks(){
				return this.config.suggestedLinks.map((link)=>{
					if(!link.favicon){
						link.favicon = favicon(link.url);
					}
					return link
				})
			},
		},
		data() {
			return {
			}
		},
		methods:{
			insertSuggested(item){
				this.$router.push({name:'formLinkSuggestion', params: { item: item }})
			},
		}
	}

</script>